import { Column, PatientProfile } from "src/api/types";
import { formatPhoneNumber } from "src/utils/formatPhoneNumber";
import format from "date-fns/format";

export const columns: readonly Column<PatientProfile>[] = [
  {
    id: "id",
    label: "ID",
    minWidth: 30,
    align: "center",
    orderable: true,
    orderBy: "id",
    format: (row) => row.id.toString(),
  },
  {
    id: "patient",
    label: "Patient",
    orderBy: "profile(first_name)",
    minWidth: 100,
    align: "center",
    orderable: true,
    format: (row) => `${row.profile.first_name} ${row.profile.last_name}`,
  },
  {
    id: "products",
    label: "Products",
    minWidth: 70,
    align: "center",
    orderable: false,
    format: (row) => {
      if (row.products.length > 0) {
        return row.products.join(", ");
      }

      return "N/A";
    },
  },
  {
    id: "created_at",
    label: "Signed up",
    minWidth: 100,
    align: "center",
    orderBy: "created_at",
    orderable: true,
    format: (row) =>
      row.created_at != null
        ? format(new Date(row.created_at), `MMM d yyyy 'at' h:mm a`)
        : "N/A",
  },
  {
    id: "region",
    label: "State",
    minWidth: 50,
    align: "center",
    orderable: false,
    format: (row) => (row.profile.region != null ? row.profile.region : "N/A"),
  },
  {
    id: "language",
    label: "Language",
    minWidth: 50,
    align: "center",
    orderable: false,
    format: (row) => row.profile.language,
  },
  {
    id: "phone_number",
    label: "Phone number",
    minWidth: 100,
    align: "center",
    orderable: false,
    format: (row) =>
      formatPhoneNumber(row.profile.phone_number)?.toString() ?? "",
  },

  {
    id: "status",
    label: "Status",
    minWidth: 80,
    align: "center",
    orderable: false,
    format: (row) => (row.status != null ? row.status : "N/A"),
  },
  {
    id: "refill_date",
    label: "Refill",
    minWidth: 120,
    align: "center",
    orderable: false,
    format: (row) => {
      if (["Canceled", "Suspended"].includes(row.status || "")) {
        return "N/A";
      }

      if (row.subscriptions.length > 0) {
        return row.subscriptions.join(", ");
      }

      return "N/A";
    },
  },
];
